import { styled } from 'styled-components';

import { Flexbox } from '@components/web/src/foundations/Flexbox/Flexbox';
import { GRADIENTS } from '@components/web/src/styles';

export const BasicServiceTermsModalContainer = styled(Flexbox)`
  border-radius: 16px;
  background: ${GRADIENTS.warmGradientReversed};
`;

export const DescriptionContainer = styled(Flexbox)`
  & > div {
    position: relative;
    min-width: 90px;
    max-width: 90px;
    height: 0px;

    img {
      position: relative;
      bottom: 50px;
      left: 50%;
      width: 126px;
      height: 126px;
      filter: drop-shadow(4px 4px 8px rgb(0 0 0 / 25%));
      transform: translateX(-50%) rotate(270deg);
    }
  }
`;
